const StagingBanner = ({ banner, token, dispatch }) => {
  return null;
};

export default StagingBanner;
